import { useTranslation } from 'react-i18next';

import { CHANNEL_MEDIA_TYPE_TO_ICON } from '../constants/icons';
import { ChannelMediaTypeEnum } from '../types';

export function useChannelMediaTypeOptions() {
  const { t } = useTranslation();

  return [
    {
      label: t('Televisón'),
      value: ChannelMediaTypeEnum.TV,
      icon: CHANNEL_MEDIA_TYPE_TO_ICON[ChannelMediaTypeEnum.TV],
    },
    {
      label: t('Radio'),
      value: ChannelMediaTypeEnum.RADIO,
      icon: CHANNEL_MEDIA_TYPE_TO_ICON[ChannelMediaTypeEnum.RADIO],
    },
    // {
    //   label: t('Audio podcast'),
    //   value: ChannelMediaTypeEnum.AUDIO_PODCAST,
    // },
    // {
    //   label: t('Streaming'),
    //   value: ChannelMediaTypeEnum.STREAMING,
    // },
  ];
}
